import { EditAppointment } from "@/features/patient/appointments/components/edit/edit-appointment";

const PatientEditAppointment = () => {
    return (
        <div className="px-4 py-8">
            <div className="container mx-auto">
                <div className="mb-4 flex">
                    <h1 className="mb-4 text-2xl font-semibold">
                        Your appointments
                    </h1>
                </div>
                <EditAppointment />
            </div>
        </div>
    );
};

export default PatientEditAppointment;
